import { render } from "./ListAgendaDashboardView.vue?vue&type=template&id=8cbb7d08"
import script from "./ListAgendaDashboardView.vue?vue&type=script&lang=js"
export * from "./ListAgendaDashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__